import { Component, Output, OnInit, EventEmitter, Input, Inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormValidation } from '../../../../classes/formValidation';
import { ISelectOptions } from '../../../../interfaces/abstract';
import { CompostFields } from '../../calculatorSettingsForm';
import { ICompostNViewModel } from '../../interfaces';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedUpdateService } from '../../../shared/dialogs/update.service';

@Component({
	moduleId: module.id,
	selector: 'compost',
	templateUrl: 'compost.html'
})

export class CompostComponent implements OnInit {

	public applicationMethods: ISelectOptions[] = [
		{ key: 0.6, value: 'Fresh, Incorporated' },
		{ key: 0.3, value: 'Fresh, Unincorporated' },
		{ key: 0.4, value: 'Medium Composted' },
		{ key: 0.2, value: 'Well Composted' },
		{ key: 0, value: 'N/A' },
	];

	public form: FormGroup;

	public get f(): { [key in CompostFields]: AbstractControl } {
		return this.form.controls as { [key in CompostFields]: AbstractControl };
	}

	private _initialValues: ICompostNViewModel;
	private _control: AbstractControl;

	constructor(
		private _dialogRef: MatDialogRef<CompostComponent>,
		@Inject(MAT_DIALOG_DATA) private _data: { form: FormGroup, control: AbstractControl },
		private _sharedUpdateService: SharedUpdateService
	) {
	}

	ngOnInit(): void {
		this.form = this._data.form;
		this._control = this._data.control;
		this._initialValues = this.form.value;
		this._setValidators();
	}

	public calculate(e: MouseEvent): void {
		let result: number;

		result = this.f.ApplicationMethod.value * this.f.Amount.value * 2000
			* this.f.N.value / 100;

		result = parseFloat(result.toFixed(2));

		this._control.setValue(result);
		this._closeDialog();
	}

	public cancel($event: MouseEvent): void {
		this.form.reset(this._initialValues);
		this._clearValidators();
		this._closeDialog();
	}

	private _closeDialog() {
		this._sharedUpdateService.cancel();
		this._dialogRef.close();
	}

	private _setValidators(): void {
		this.f.Amount.setValidators([ Validators.required, Validators.min(0)]);

		this.f.ApplicationMethod.setValidators([Validators.required,
			Validators.min(0.1)]);

		this.f.N.setValidators([Validators.required, Validators.min(0),
			Validators.max(100)]);
	}

	private _clearValidators(): void {
		FormValidation.clearValidator(this.f.Amount);
		FormValidation.clearValidator(this.f.ApplicationMethod);
		FormValidation.clearValidator(this.f.N);
	}
}
